// @flow

import React from "react";
import SVG from "react-inlinesvg";
import cx from "classnames";

import bottomCaret from "../../assets/icons/other/bottomCaret.svg";
import upCaret from "../../assets/icons/other/upCaret.svg";
import styles from "./Section.scss";

type SectionTitleProps = {
  children: string,
  expansionState: null | "expanded" | "collapsed",
  numbered?: boolean,
  numberedWithDot?: boolean,
  isExpandable?: boolean
};

const SectionTitle = ({
  children,
  expansionState,
  numbered,
  numberedWithDot,
  isExpandable
}: SectionTitleProps) => (
  <h2
    className={cx(styles.title, {
      [styles.numbered]: numbered,
      [styles.numberedWithDot]: numberedWithDot,
      [styles.isExpandableTitle]: isExpandable
    })}
  >
    {children}
    <span className={styles.expansionIndicator}>
      {expansionState === "expanded" && <SVG cacheGetRequests src={bottomCaret} alt="Anzeigen" />}
      {expansionState === "collapsed" && <SVG cacheGetRequests src={upCaret} alt="Verbergen" />}
    </span>
  </h2>
);

SectionTitle.defaultProps = {
  expansionState: null,
  numbered: false,
  numberedWithDot: false,
  isExpandable: false
};

export default SectionTitle;
